import { boxEmptyHeight } from '../config'
import { deviceEvent, getClient, findScrollContainer } from '../utils'
let scrollBarTimer
export default {
  data () {
    return {
      // 滚动相关
      showVScrollbar: true,
      showHScrollbar: true,
      // 滚动数据存储，
      scroll: {
        top: 0,
        left: 0,
        sdisy: 0,
        disx: 0, // 滚动 水平距离
        disy: 0, // 滚动 垂直距离
        vScrolling: false
      },
      isScrolling: false,

    }
  },
  mounted () {
    // 数据显示的配置
    this.canvasConfig = {
      ah: 0,
      aw: 0
    }
    // 锁定滚动 计算数据，渲染画面，
    // 例如：滚动到顶部，用户再次向上滚动就没有必要计算，渲染画图了
    this.lockRender = 0
    this.lockScrollTop = 0
    this.lockScrollBottom = 0
    // this.isScrolling = false
    this.canvasBoxWidth = 100
    this.isBindScrollEvent = false
  },
  methods: {
    // 初始化滚动条,初始化布局，获取初始显示的行和列的数据
    initScroll () {
      // 横向滚动条
      const { allRowData, allColData, box, canvas, rowH, ratio,
        flatData, cHeight, hScrollbar, vertical, horizontal,
        vScrollbar, canvasBox, divideLine, headerHeight, twoHeander, options } = this
      if (!canvas) {
        return
      }
      const hHeight = headerHeight * ratio
      let cw = box.offsetWidth * ratio
      let aw = allColData.reduce((c, v) => c += v.width, 0) // 列总宽度
      let ch = Math.max(cHeight, canvas.offsetHeight)
      let ah = hHeight + allRowData.length * rowH // 行总高度
      if (aw <= cw) {
        this.showHScrollbar = false
        canvasBox.style.width = aw / ratio + 'px'
        this.canvasBoxWidth = aw
        this.scroll.disx = 0
      } else {
        this.showHScrollbar = true
        hScrollbar.style.width = (cw * cw / aw / ratio) + 'px'
        canvasBox.style.width = cw / ratio + 'px'
        this.canvasBoxWidth = cw
      }
      // 循环到最后还是没有超过canvas的高度， 设置dix的高度
      let boxHeight = cHeight
      // 容错处理
      // if (ah === canvas.offsetHeight) {
      //   ch = ch * ratio
      // }
      // 当没有数据的时候
      if (flatData.length === 0) {
        this.showVScrollbar = false
        this.scroll.disy = 0
        if (options.headerHeight) {
          boxHeight = headerHeight + this.rowHeight
        } else {
          boxHeight = twoHeander ? (boxEmptyHeight + headerHeight / 2) : boxEmptyHeight
        }
      } else if (ah <= ch) {
        // 当总数据行高度 小于 canvas高度的时候
        this.showVScrollbar = false
        this.scroll.disy = 0
        boxHeight = (ah / ratio)
      } else {
        this.showVScrollbar = true
        let vsh = (boxHeight - hHeight) * (boxHeight - hHeight) / ah
        // 垂直滚动条最小高度为50
        vScrollbar.style.height = (vsh < 50 ? 50 : vsh) + 'px'
      }
      horizontal.style.width = cw / ratio + 'px'
      vertical.style.top = headerHeight + 'px'
      vertical.style.height = (boxHeight - headerHeight) + 'px'
      box.style.height = boxHeight + 'px'
      divideLine.style.height = boxHeight + 'px'
      this.changeDividTagHeight(headerHeight)
      this.setCanvas()
      if (this.showVScrollbar && this.canvasConfig.ah > 0 && this.scroll.disy > 0) {
        let disy = ah - this.canvasConfig.ah
        if (disy < 0) {
          this.scroll.disy += disy
          this.scroll.disy < 0 && (this.scroll.disy = 0)
        }
      }
      this.canvasConfig.ah = ah
      this.canvasConfig.aw = aw
      if (!this.isBindScrollEvent) {
        this.scrollEvent()
      }
      if (this.dialog && this.showHScrollbar && options.hScrollbarSticky === true) {
        this.addHScrollBarIntersectionObserver()
      }
    },
    changeDividTagHeight (h) {
      this.divideTag.style.height = h + 'px'
    },
    // 滚动事件
    scrollEvent () {
      const { canvas, hScrollbar, vScrollbar } = this
      // 滚动条事件
      hScrollbar.addEventListener(deviceEvent.startEvent, this.hScrollbarMouseDown)
      vScrollbar.addEventListener(deviceEvent.startEvent, this.vScrollbarMouseDown)
      canvas.addEventListener('wheel', this.vMouseWheel, { passive: false })
      this.isBindScrollEvent = true
    },
    // 横向滚动条鼠标按下
    hScrollbarMouseDown (e) {
      const { hScrollbar } = this
      let clientX = getClient(e).x
      this.scroll.left = clientX - hScrollbar.offsetLeft
      this.resetEditCell()
      this.setTooltipPosition()
      this.closeEditMode()
      document.addEventListener(deviceEvent.moveEvent, this.hScrollbarMouseMove)
      document.addEventListener(deviceEvent.endEvent, this.hScrollbarMouseUp)
    },
    // 横向滚动条鼠标移动
    hScrollbarMouseMove (e) {
      let clientX = getClient(e).x
      let left = -this.scroll.left
      let dis = clientX + left
      this.toHMove(dis)
    },
    toHMove (dis) {
      const { hScrollbar, horizontal, canvas } = this
      let disW = horizontal.offsetWidth - hScrollbar.offsetWidth
      const render = () => {
        if (this.lockRender <= 2) {
          this.isCanvasMove = false
          hScrollbar.style.left = dis + 'px'
          const overWidth = this.canvasConfig.aw - canvas.offsetWidth
          const percent = dis / disW
          this.isScrolling = true
          this.scroll.disx = Math.round(percent * overWidth) // 计算出到canvase滚动宽度
          this.getDisplayCol()
          this.handleShowText()
          this.paint()
          this.$emit('hScroll', this.scroll.disx)
          this.tableScrollEvent('X')
        }
      }
      if (dis <= 0) {
        dis = 0
        this.lockRender += 1
      } else if (dis > disW) {
        dis = disW
        this.lockRender += 1
      } else {
        this.lockRender = 0
      }
      render()
    },
    // 横向滚动条鼠标抬起，清除document 事件，避免内存泄漏
    hScrollbarMouseUp (e) {
      document.removeEventListener(deviceEvent.moveEvent, this.hScrollbarMouseMove)
      document.removeEventListener(deviceEvent.endEvent, this.hScrollbarMouseUp)
      this.scroll.hScrolling = (this.scroll.disx > 0)
      this.isCanvasMove = true
      this.isScrolling = false
      // this.paint()
    },
    // 垂直滚动条鼠标按下
    vScrollbarMouseDown (e) {
      const { vScrollbar } = this
      let clientY = getClient(e).y
      this.scroll.top = clientY - vScrollbar.offsetTop
      this.setTooltipPosition()
      this.resetEditCell()
      this.closeEditMode()
      document.addEventListener(deviceEvent.moveEvent, this.vScrollbarMouseMove)
      document.addEventListener(deviceEvent.endEvent, this.vScrollbarMouseUp)
    },
    // 垂直滚动条鼠标移动
    vScrollbarMouseMove (e) {
      let clientY = getClient(e).y
      let top = -this.scroll.top
      let dis = clientY + top
      this.toVscrollMouseMove(dis)
    },
    toVscrollMouseMove (dis) {
      const { vScrollbar, vertical, canvasConfig, canvas } = this
      let disH = vertical.offsetHeight - vScrollbar.offsetHeight
      const render = () => {
        if (this.lockScrollTop <= 2) {
          this.isScrolling = true // 正在滚动中状态
          vScrollbar.style.top = (dis - 2) + 'px'
          const overHeight = canvasConfig.ah - canvas.offsetHeight
          const percent = dis / disH
          this.isScrolling = true
          this.scroll.disy = Math.round(percent * overHeight) // 计算出到canvase滚动宽度
          this.getDisplayRow()
          this.handleShowText()
          this.paint()
          this.tableScrollEvent('Y')
        }
      }
      this.isCanvasMove = false
      if (dis <= 0) {
        dis = 0
        this.lockScrollTop += 1
      } else if (dis >= disH) {
        dis = disH
        this.lockScrollTop += 1
      } else {
        this.scroll.vScrolling = true
        this.lockScrollTop = 0
      }
      render()
    },
    // 垂直滚动条鼠标抬起
    vScrollbarMouseUp (e) {
      document.removeEventListener(deviceEvent.moveEvent, this.vScrollbarMouseMove)
      document.removeEventListener(deviceEvent.endEvent, this.vScrollbarMouseUp)
      this.scroll.vScrolling = false
      this.isCanvasMove = true
      this.isScrolling = false
      this.paint()
    },
    // 鼠标滚轮滚动事件
    vMouseWheel (e) {
      const shiftKey = e.shiftKey
      const { showHScrollbar, showVScrollbar } = this
      const { deltaX, deltaY } = e
      this.isPaintImage = true
      this.slotTooltip.show = false
      // 判断是横向滚动还是纵向滚动
      let isHScroll = Math.abs(deltaX) > Math.abs(deltaY)
      // 横向滚动
      if (isHScroll && showHScrollbar) {
        e.preventDefault()
        this.toHWheel(deltaX)
      } else if (!isHScroll && showHScrollbar && shiftKey) {
        // 当键盘按下shift键的时候也是横向滚动
        this.toHWheel(deltaY, e)
      } else if (!isHScroll && showVScrollbar) {
        // 垂直溢出高度
        this.toVWheel(deltaY, e)
      }
    },
    // 横向滚动操作
    toHWheel (deltaX) {
      const { scroll, canvas, horizontal, hScrollbar } = this
      // 数据溢出出宽度 = 数据的总宽度 - canvas宽度
      const disW = horizontal.offsetWidth - hScrollbar.offsetWidth
      const overWidth = this.canvasConfig.aw - canvas.offsetWidth
      let disx = scroll.disx + deltaX
      // 横向滚动距离 如果小于 0
      if (disx <= 0) {
        disx = 0
        this.lockRender += 1
      } else if (disx >= overWidth) {
        // 横向滚动距离 >= 数据溢出出宽度
        disx = overWidth
        this.lockRender += 1
      } else {
        this.lockRender = 0
        // e.preventDefault()
      }
      // this.isScrolling = !!deltaX
      // 如果是滚动到最左 或者 最右， 就停止滚动避免浪费性能，只有中间滚动才计算数据，画图操作
      if (this.lockRender < 2) {
        this.setTooltipPosition()
        // 2021-11-23 横向滚动清除头部提示
        this.setHeaderTipPositin()
        this.resetEditCell()
        this.scroll.disx = disx
        hScrollbar.style.left = (disx / overWidth) * disW + 'px'
        this.getDisplayCol()
        this.handleShowText()
        this.closeEditMode()
        this.paint()
        this.$emit('hScroll', disx)
        this.tableScrollEvent('X')
      }
    },
    toVWheel (deltaY, e) {
      const { scroll, canvas, vertical, vScrollbar } = this
      const overHeight = this.canvasConfig.ah - canvas.offsetHeight
      const disH = vertical.offsetHeight - vScrollbar.offsetHeight
      let disy = scroll.disy + deltaY
      scroll.sdisy += deltaY
      // 垂直滚动，指向计算数据，画图操作函数
      const scrollYRender = (isScroll = true) => {
        if (isScroll) {
          this.setTooltipPosition()
          this.resetEditCell()
          vScrollbar.style.top = ((disy / overHeight) * disH - 2) + 'px'
          scroll.disy = disy
          scroll.sdisy = 0
          this.getDisplayRow()
          this.handleShowText()
          this.closeEditMode()
          this.paint()
          this.tableScrollEvent('Y')
        }
      }
      if (disy <= 0) {
        disy = 0
        this.lockScrollTop += 1
        this.lockScrollBottom = 0
        // 每次滚动到顶部，保证只执行一次，以免浪费计算性能
        scrollYRender(this.lockScrollTop < 2)
      } else if (disy >= overHeight) {
        disy = overHeight
        this.lockScrollTop = 0
        this.lockScrollBottom += 1
        // 每次滚动到底部，保证只执行一次，以免浪费计算性能
        scrollYRender(this.lockScrollBottom < 2)
      } else {
        this.lockScrollTop = 0
        this.lockScrollBottom = 0
        // 中间滚动都会执行计算
        if (scroll.sdisy >= 16 || scroll.sdisy <= -16) {
          scrollYRender()
        }
        e && e.preventDefault()
      }
    },
    // emit滚动事件
    tableScrollEvent (type) {
      const { hScrollbar, vScrollbar } = this
      this.$emit('table-scroll', {
        type,
        disx: this.scroll.disx,
        disy: this.scroll.disy,
        scrollLeft: hScrollbar.offsetLeft,
        scrollTop: vScrollbar.offsetTop
      })
    },
    setScrollLeft (left) {
      // left 滚动条到最右边表格距离
      const { canvas, box, canvasConfig, allColData, scroll, hScrollbar, horizontal, ratio } = this
      // 盒子宽度
      const boxWidth = box.offsetWidth * ratio
      // 列总宽度
      const allColWidth = allColData.reduce((c, v) => c += v.width, 0)

      this.$nextTick(() => {
        // 数据溢出出宽度 = 数据的总宽度 - canvas宽度
        let disW = horizontal.offsetWidth - hScrollbar.offsetWidth
        const overWidth = canvasConfig.aw - canvas.offsetWidth

        let _left = parseInt(left) || 0

        if (allColWidth >= boxWidth && _left > 0) {
          // 横向滚动距离 >= 数据溢出出宽度
          if (_left >= disW) {
            _left = disW
          }
          // 计算出到canvase滚动宽度
          hScrollbar.style.left = _left + 'px'
          scroll.disx = Math.round((_left / disW) * overWidth)
          this.getDisplayCol()
          this.handleShowText()
          this.paint()
        }
      })
    },
    // 添加水平滚动条的动态位置计算
    addHScrollBarIntersectionObserver() {
      if (!this.$el || this.scrollBarIntersectionObserver) return
      const viewportContainer = findScrollContainer(this.$el)
      const threshold = Array.from({ length: 101 }, (_, i) => (0.10 + i * 0.009).toFixed(2))
      this.scrollBarIntersectionObserver = new IntersectionObserver(entries => {
        this.updateHScrollBarPosition(entries)
        clearTimeout(scrollBarTimer)
        scrollBarTimer = setTimeout(() => {
          this.getIntersectionObserverEntries()
        }, 300)
      }, {
        threshold,
        root: viewportContainer || null
      })
      this.scrollBarIntersectionObserver.observe(this.$el)
    },
    updateHScrollBarPosition(entries) {
      const { intersectionRatio, intersectionRect = {}, rootBounds = {}, boundingClientRect = {} } = entries[0] || {}
      const isBottomVisibleInContainer = boundingClientRect.bottom <= rootBounds.bottom
      const horizontal = this.$refs.horizontal
      if (!horizontal) return
      // 设置滚动条位置
      if (intersectionRatio > 0 && isBottomVisibleInContainer === false) {
        const top = intersectionRect.height - 10 // 10滚动条高度
        horizontal.style.position = 'absolute'
        horizontal.style.top = `${top < this.headerHeight ? this.headerHeight : top}px`
      } else {
      // 重置
        horizontal.style.position = ''
        horizontal.style.top = ''
      }
    },
    getIntersectionObserverEntries() {
      const { scrollBarIntersectionObserver, $el } = this
      if (!scrollBarIntersectionObserver || !scrollBarIntersectionObserver.root) return
      const targetRect = $el.getBoundingClientRect()
      const rootRect = scrollBarIntersectionObserver.root.getBoundingClientRect()
      const visibleAreaHeight = Math.min(targetRect.height, rootRect.height - (targetRect.top - rootRect.top))
      const _intersectionRatio = visibleAreaHeight / targetRect.height
      const entries = [{
        intersectionRatio: _intersectionRatio > 0.99 ? 1 : _intersectionRatio,
        intersectionRect: {
          height: visibleAreaHeight > targetRect.height ? targetRect.height : visibleAreaHeight
        },
        boundingClientRect: targetRect,
        rootBounds: rootRect
      }]
      this.updateHScrollBarPosition(entries)
    }
  },
  beforeDestroy () {
    const { canvas, hScrollbar, vScrollbar, scrollBarIntersectionObserver } = this
    hScrollbar.removeEventListener(deviceEvent.startEvent, this.hScrollbarMouseDown)
    vScrollbar.removeEventListener(deviceEvent.startEvent, this.vScrollbarMouseDown)
    canvas && canvas.removeEventListener('wheel', this.vMouseWheel, { passive: false })
    clearTimeout(scrollBarTimer)
    scrollBarIntersectionObserver && scrollBarIntersectionObserver.disconnect()
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-canvas-table/mixins/scroll.js